module.exports = __webpack_public_path__ + "static/placeholder-dd025777cc988057945fee26bb5d5593.jpeg";